import { APPLICATION_NAME } from 'constants/settings';

const KEY_LOCAL_STORAGE = `${APPLICATION_NAME}_data`;

type Props = {
  exam?: any;
};

// LƯU Ý: nếu data trả về render ra giao diện thì phải dùng useEffect để lưu vào giá trị vào state, rồi dùng state đưa giá trị ra giao diện
function getItemLocalStorage(): Props {
  const jsonValues = localStorage.getItem(KEY_LOCAL_STORAGE);
  const values = jsonValues ? JSON.parse(jsonValues) : {};
  return values;
}

function setItemLocalStorage(data: Props) {
  const oldValues = getItemLocalStorage();
  const newValues = JSON.stringify({ ...oldValues, ...data });
  localStorage.setItem(KEY_LOCAL_STORAGE, newValues);
}

function removeItemLocalStorage() {
  localStorage.removeItem(KEY_LOCAL_STORAGE);
}

export { setItemLocalStorage, getItemLocalStorage, removeItemLocalStorage };
